/*
 * File: d:\projects\AutoFiFront\src\Content\SVG\BrandSVG\SEAT.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday March 10th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday March 10th 2023 5:22:48 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { SVGProps } from 'Content/SVG/SVGProps';

function SEAT(props: SVGProps) {
    return(
        <svg id="Calque_1" fill={props.fill} data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080">
            <g id="Group">
                <path id="Fill-3" d="M289.77,477.2c.41-17.13,1.44-59.05,2.22-83.76,1.01-31.6,7.25-50.85,19.5-62.44,16.9-15.99,36.61-19.81,83.68-22.53,109.05-6.32,220.05-5.45,359.16,4.93,14.47,1.08,19.95,3.98,22.8,6.07,6.15,4.49,6.93,9.53,8.56,35.84,.95,15.05,2.84,55.21,3.85,77.29-47.98-2.62-129.41-7.08-200.36-7.84-70.94-.76-134.81,.46-142.39,1.49-15.51,2.11-22.62,9.83-24.71,13.21l368.14,72.72v57.25l-500.46-92.24Z"/>
                <path id="Fill-5" d="M289.77,510.56l500.46,95.63c-.34,13.96-1.46,58.26-2.3,83.65-1.01,30.45-7.26,48.98-19.5,60.14-16.9,15.4-36.61,19.06-83.67,21.7-109.03,6.08-220.01,5.23-359.11-4.76-14.47-1.03-19.94-3.83-22.8-5.84-6.15-4.33-6.93-9.17-8.57-34.5-1.1-16.95-3.49-66.99-4.27-83.54,64.53,4.47,163.66,7.75,244.46,7.75,20.29,0,73.04,.66,87.07,.66,10.97,0,25.74-3.09,33.21-15.07l-364.99-63.89v-61.92Z"/>
            </g>
        </svg>
    );
}

export default SEAT;
